// extracted by mini-css-extract-plugin
export var cardLayout = "_5m-1";
export var paginationContainer = "_5m-0";